import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";

export default function Done() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  // const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (search && search.trim() !== "") {
        dispatch(getType("done", "done", search));
      } else {
        dispatch(getType("done", "done", ""));
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  return (
    <div>
      {user !== "user" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <h1 className="text-2xl pt-0 pl-6 pb-5 text-white">Done Students</h1>
          <div className="flex justify-center">
            <div
              className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow
    flex flex-col bg-white p-6 rounded-lg"
            >
              <StudentList
                students={students}
                setSearch={setSearch}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
